export default "__VITE_ASSET__CDjcL3K1__"